import { Fragment, type FC } from 'react';
import classNames from 'classnames/bind';
import { Link } from 'react-router-dom';
import { VoloPassYellowBadge } from '@rivallapp/volosports-components';
import Tooltip from '../../../../../components/Tooltip';
import { getPerkDetails, VenuePerksEnum } from '../../../../../shared/venue-features-enum';
import { sortFeatureIcons } from '../utilities';
import styles from '../../../../../styles/main.module.scss';

const cx = classNames.bind(styles);

type Props = {
  leagueId: string;
  venueFeatures?: VenuePerksEnum[];
  isVoloPassExclusive?: boolean;
};

const DiscoverCardFeatures: FC<Props> = props => {
  const { venueFeatures = [], leagueId, isVoloPassExclusive } = props;

  const to = `/l/${leagueId}`;

  return (
    <div className={cx('venue-features')}>
      {venueFeatures.length > 0 && (
        <>
          {sortFeatureIcons(venueFeatures)
            .slice(0, isVoloPassExclusive ? 4 : 5)
            .map((f, i) => {
              const key = `feature-${i}`;
              return (
                <Fragment key={key}>
                  <div
                    data-for={`tip-${i}`}
                    data-tip={`${getPerkDetails(f).LABEL}`}
                    className="d-flex justify-content-center align-items-center"
                  >
                    <img
                      alt="feature"
                      className={cx('feature')}
                      src={(getPerkDetails(f)?.ICON as string) || ''}
                    />
                  </div>
                  <Tooltip id={`tip-${i}`} />
                </Fragment>
              );
            })}
          {isVoloPassExclusive && (
            <>
              <div
                data-for="tip-vp-exclusive"
                data-tip="Volo Pass Member Exclusive"
                className={cx('feature', 'd-flex justify-content-center align-items-center')}
              >
                <VoloPassYellowBadge size={5} />
              </div>
              <Tooltip id="tip-vp-exclusive" />
            </>
          )}
          <div
            data-for="overflow-tip"
            data-tip="View all perks"
            className="d-flex justify-content-center align-items-center"
          >
            <div className={cx('feature-overflow')} style={{ cursor: 'pointer' }}>
              <span>
                <Link to={to}>&nbsp;...&nbsp;</Link>
              </span>
            </div>
          </div>
          <Tooltip id="overflow-tip" />
        </>
      )}
    </div>
  );
};

export default DiscoverCardFeatures;
